export default __webpack_public_path__ + "static/media/mobile.eb899665.svg";